import React, {useState} from 'react'
import "./basic_data_module.css"
import Formatters from "../utils/formatters";
import Headers from "../utils/headers";
import Downloader from "../utils/downloader";
import ModuleFilters from "./module_filters";
//import ChartModule from "./chart_module";
import Table from "../../views/charts/table"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faSearchPlus} from "@fortawesome/free-solid-svg-icons/faSearchPlus";
import {faSearchMinus} from "@fortawesome/free-solid-svg-icons/faSearchMinus";
import {faSync} from "@fortawesome/free-solid-svg-icons/faSync";
import {faFileCsv} from "@fortawesome/free-solid-svg-icons/faFileCsv";
import {faDatabase} from "@fortawesome/free-solid-svg-icons/faDatabase";
import SqlEditor from "../sql-editor";
import ColourUtils from "../utils/colourutils";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {faLink} from "@fortawesome/free-solid-svg-icons";

const BasicDataModule = ({
                        feed,
                        statusMsg = '',
                        formatters={},
                        headers = {},
                        title = "",
                        publicLinks = [],
                        className='',
                        onRequestRefresh = {},
                        filters = {},
                        onFilterChange = {},
                        onCloseClick = {},
                        onCopyLinkClick = {},
                        sql=""
}) => {

    const hasData           = feed && feed.data
    const hasFilters        = Object.keys(filters).length > 0
    const downloader        = Downloader()
    const genericFormatter  = Formatters().generic
    const genericHeader     = Headers().generic
    const hue               = ColourUtils().stringToHue(title)
    const [sortColumns, setSortColumns]           = useState([])
    const [filtersCollapsed, setFiltersCollapsed] = useState(true)
    const [sqlEditorCollapsed, setSqlEditorCollapsed] = useState(true)
    const [publicLinksCollapsed, setPublicLinksCollapsed] = useState(true)
    const formatters_merged = hasData ?
        feed.cols.map( (col, i) => {
            return formatters[col] || Formatters().byColumnName(col) || genericFormatter
        } ) : []
    const headers_merged = hasData ?
        feed.cols.map( (col, i) => {
            return headers[col] || genericHeader
        } ) : []

    const downloadCsv = (e) => {
        downloader.downloadCsv(feed, title)
    }

    const toggleFilters = (e) => {
        setFiltersCollapsed(!filtersCollapsed)
    }

    const onHeaderClick = (e) => {
        const sortColumn = parseInt(e.target.getAttribute("data-column"))
        const direction = (sortColumns[0] && sortColumns[0].index === sortColumn) ?
            (sortColumns[0].direction === 'asc') ? 'desc' : 'asc'
            : 'desc'
        const newColumns = sortColumns.filter( c => c.index !== sortColumn)
        newColumns.unshift({index:sortColumn, direction:direction})
        setSortColumns(newColumns)
    }

    const onSqlIconClick = (e) => {
        setSqlEditorCollapsed(!sqlEditorCollapsed)
    }

    const onLinkIconClick = (e) => {
        console.debug("publicLinkCollapsed", publicLinksCollapsed)
        if(!publicLinks || !publicLinks.length){
            setPublicLinksCollapsed(false)
            onCopyLinkClick(e)
        } else {
            setPublicLinksCollapsed(!publicLinksCollapsed)
        }
    }

    const ToggleFiltersIcon = ({isFiltersCollapsed, isAvailable}) => {
        const availableCss = isAvailable ? "" : "disabled"
       return <span className={`icon ${availableCss}`} onClick={toggleFilters} title={"Show/hide filters"}>
                <FontAwesomeIcon icon={isFiltersCollapsed ? faSearchPlus : faSearchMinus} />
       </span>
    }

    const SyncIcon = ({onClick}) => {
        return <span className={"icon"} onClick={onClick} title={"Reload data"}>
            <FontAwesomeIcon icon={faSync} />
        </span>
    }
    const CsvIcon = ({onClick}) => {
        return <span className={"icon"} onClick={onClick} title={"Download data in Excel CSV format"}>
            <FontAwesomeIcon icon={faFileCsv}/>
        </span>
    }
    const SqlIcon = ({onClick}) => {
        return <span className={"icon"} onClick={onClick} title={"Show SQL of the query"}>
            <FontAwesomeIcon icon={faDatabase}/>
        </span>
    }
    const CloseIcon = ({onClick}) => {
        return <span className={"icon"} onClick={onClick} title={"Hide/unhide the module"}>
            <FontAwesomeIcon icon={faTimes}/>
        </span>
    }
    const LinkIcon = ({onClick}) => {
        return <span className={"icon"} onClick={onClick} title={"public URL to the source data"}>
            <FontAwesomeIcon icon={faLink}/>
        </span>
    }

    const PublicLinks = ({links, className}) => {
        return  <ul className={`publicLinks ${className}`}>
            <ol>public links</ol>
            {
            (links && links.length) ? links.map( link => <li><a href={link.url} target={"_blank"}>{link.text}</a></li>) : null
        }</ul>
    }

    return (
        <div className={`dashboardItem ${className}`} style={{'--hue': hue}}>

            <span className={"title"}><CloseIcon onClick={onCloseClick}/> {title}</span>
            <span className={"icons"}>
                <CsvIcon onClick={downloadCsv}/>
                <LinkIcon onClick={onLinkIconClick} />
                <SyncIcon onClick={onRequestRefresh}/>
                <SqlIcon onClick={onSqlIconClick}/>
                <ToggleFiltersIcon isFiltersCollapsed={filtersCollapsed} isAvailable={hasFilters}/>
            </span>
            <ModuleFilters filters={filters} onChange={onFilterChange} className={filtersCollapsed ? "collapsed" : ""}/>
            <SqlEditor sql={sql} className={sqlEditorCollapsed ? "collapsed" : ""}/>
            <PublicLinks links={publicLinks} className={publicLinksCollapsed ? "collapsed" : ""}/>
            <Table data={feed.data}
                   cols={feed.cols}
                   sortColumns={sortColumns}
                   headers={headers_merged}
                   formatters={formatters_merged}
                   onHeaderClick={onHeaderClick}
            />
            <span className={"status"}>{statusMsg}</span>
        </div>
    )
}

export default BasicDataModule